import React, { Component } from "react";
import { withRouter } from "react-router-dom";

class ScrollToTop extends Component {
	
	constructor(){
		super()
		this.doUpdate = this.doUpdate.bind(this);
	}
	
	componentDidMount() {
		this.doUpdate(false);
	}
	
	componentDidUpdate(prevProps) {
		this.doUpdate(prevProps);
	}
	
	doUpdate(prevProps) {
		if (this.props.location !== prevProps.location || !prevProps.location) {
			window.dispatchEvent(new Event('resize'));
			window.scrollTo(0, 1000);
			if (window.location.hash) {
				let id = window.location.hash.replace('#','');
				
				setTimeout(function(){
					if (document.getElementById(id)) {
						window.scrollTo(0, document.getElementById(id).offsetTop);
					}
					setTimeout(function(){
						window.scrollTo(0, document.getElementById(id).offsetTop);
						window.dispatchEvent(new Event('resize'));
					}, 0);
				}, 0);
			} else {
				window.scrollTo(0, 0);
				setTimeout(function(){
					window.dispatchEvent(new Event('resize'));
				}, 0);
			}
			
		}
	}

	render() {
		return <React.Fragment />
	}
}

export default withRouter(ScrollToTop);